import { useMemo } from 'react';
import { Tag } from 'antd';
import { STATUS_COLORS, STATUS_ICONS } from '../constants';

export const useStatusRender = () => {
  return useMemo(
    () => (status: string) => {
      const color =
        STATUS_COLORS[status as keyof typeof STATUS_COLORS] || 'default';
      const icon = STATUS_ICONS[status as keyof typeof STATUS_ICONS] || '?';

      return (
        <Tag color={color} style={{ fontWeight: 500 }}>
          {icon} {status}
        </Tag>
      );
    },
    []
  );
};
